import React from "react";
import classnames from "classnames";
import ShowMore from "../../../../../components/showMore";
import Label from "../../../../../components/label/Label";
import { maskLegacyBulletDamage } from "../../../../../util/maskLegacyBulletDamage";
import "./index.scss";

const AboutMe = ({ aboutMe, fromTalent, client }) => {
  return (
    <div className={classnames((fromTalent) ? "freelancerModalComponentWrap ml-0" : "freelancerModalComponentWrap", client ? "boxShadowNone" : "")}>
      {
        aboutMe ?
          <>
            {/* {!client && <Label label='Additional Profile Information' className="font18Black boldFont mt-3 mb-0"></Label>} */}
            <Label
              label="About Me"
              className={classnames(client ? "font18Black sectionTitleWrapper" : "font18Black boldFont sectionTitleWrapper")}
            />
            <div className="font16Black mt-2">
              <ShowMore
                text={maskLegacyBulletDamage(aboutMe)}
                more="More"
                less="Less"
                textClass="font16Grey"
                anchorClass="font14Blue noWrap"
                lines={5}
                lineHeight={20}
                id={"freelanceAboutMe"}
              />
            </div>
          </>
          : ""
      }
    </div>
  );
};

export default AboutMe;
